import React from "react";
import { Container } from "react-bootstrap";
import { useIsMobile } from "../../utils/responsive";
export default function Banner2() {
  const isMobile = useIsMobile();

  return (
    <Container fluid className="p-0">
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            className="border-bottom-black border-right-black"
            style={{
              width: "5%",
            }}
          ></div>
        )}
        <div
          className={`border-bottom-black `}
          style={{
            width: isMobile ? "100%" : "90%",
            borderBottom: "1px solid black",
          }}
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 150px",
            }}
          >
            <p className="body-lg m-0 text-center">
              "GREAT DESIGN IS NOT ABOUT ADDING MORE, BUT ABOUT REVEALING WHAT
              TRULY MATTERS.
              <span className="accent-text">
                Every detail should have a purpose, every element a meaning."
              </span>
            </p>
          </div>
        </div>
        {!isMobile && (
          <div
            className="border-bottom-black border-left-black"
            style={{
              width: "5%",
            }}
          ></div>
        )}
      </div>
    </Container>
  );
}
